import Vue from "vue";
import App from "./App";

// --- 1. 核心路由与状态管理 ---
import router from "./router";
import store from "@/store/index";
import i18n from "./i18n";
import { createPinia, PiniaVuePlugin } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

// --- 2. D2Admin 业务配置数据 ---
import menuHeader from "@/menu/header";
import menuAside from "@/menu/aside";
import { frameInRoutes } from "@/router/routes";

// --- 3. 引入抽离的各个模块  ---
import setupPlugins from '@/libs/plugins';
import setupDirectives from '@/libs/directives';
import setupPrototype from '@/libs/global/prototype';
import setupElement from '@/libs/plugins/element';
import '@/libs/filter'; // 直接引入执行即可

// --- 4. 插件注册 ---
Vue.use(PiniaVuePlugin);
setupPlugins(Vue);
setupDirectives(Vue);
setupPrototype(Vue);
setupElement();

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// --- 5. 路由就绪后初始化
router.onReady(() => {
  store.dispatch("d2admin/tagsView/initAffixTags");
  const { name, meta } = router.currentRoute;
  if (name && !meta?.hidden) {
    store.dispatch("d2admin/tagsView/addView", router.currentRoute);
  }
});

// --- 6. 实例化 Vue ---
new Vue({
  router,
  store,
  pinia,
  i18n,
  render: (h) => h(App),

  // 负责菜单、页面和搜索的初始化
  created() {
    this.$store.commit("d2admin/page/init", frameInRoutes);
    this.$store.commit("d2admin/menu/headerSet", menuHeader);
    this.$store.commit("d2admin/menu/asideSet", menuAside);
    this.$store.commit("d2admin/search/init", menuHeader);
  },

  //负责系统信息、用户信息及监听器初始化
  mounted() {
    this.$store.commit("d2admin/releases/versionShow");
    this.$store.dispatch("d2admin/account/load");
    this.$store.commit("d2admin/ua/get");
    this.$store.dispatch("d2admin/fullscreen/listen");

    const { name, meta } = this.$route;
    if (name && !meta?.hidden) {
      this.$store.dispatch("d2admin/tagsView/addView", this.$route);
    }
  },
}).$mount("#app");
